import { classNames } from 'libs/react';
import { getColumnAlign } from './schema';
import { isMinWidth } from './schema';
import { React } from 'libs/react';
import './TableCell.scss';
/**
 * @component TableCell
 * @since 1.0.0
 * @hidden
 */
export function TableCell(props) {
    const { style, label, column, onClick } = Object.assign({ style: 'normal' }, props);
    const align = props.align || getColumnAlign(column) || 'left';
    const className = classNames('table-cell', 'table-cell--' + style, 'table-cell--' + align, { 'table-cell--nowrap': isMinWidth(column) }, { 'table-cell--truncate': !!(column === null || column === void 0 ? void 0 : column.truncate) }, (column === null || column === void 0 ? void 0 : column.sticky) ? 'table-cell--sticky-' + column.sticky : null);
    const inline = (column === null || column === void 0 ? void 0 : column.minWidth) ? { minWidth: column.minWidth } : undefined;
    return (React.createElement("td", { className: className, style: inline, "data-label": label, onClick: onClick }, props.children));
}
